import React from 'react';
import { useLocation } from 'react-router-dom';
import AIAssistantBadge from '../AI/AIAssistantBadge';
import BoltBadge from '../UI/BoltBadge';

interface AILayoutProps {
  children: React.ReactNode;
}

const AILayout: React.FC<AILayoutProps> = ({ children }) => {
  const location = useLocation();
  
  // Get page context from current route
  const getPageContext = (pathname: string): string => {
    const path = pathname.toLowerCase();
    
    if (path.includes('smart-kitchen')) return 'smart-kitchen';
    if (path.includes('food-scanner')) return 'food-scanner';
    if (path.includes('recipe-generator')) return 'recipe-generator';
    if (path.includes('nutrition-analysis')) return 'nutrition-analysis';
    if (path.includes('meal-planner')) return 'meal-planner';
    if (path.includes('dashboard')) return 'dashboard';
    if (path.includes('recipes')) return 'recipes';
    if (path.includes('ar-cooking')) return 'ar-cooking';
    if (path.includes('health-integration')) return 'health-integration';
    if (path.includes('subscription')) return 'subscription';
    if (path.includes('food-recognition')) return 'food-scanner';
    if (path.includes('ai-assistant')) return 'general';
    
    return 'general';
  };

  const pageContext = getPageContext(location.pathname);

  return (
    <>
      {children}
      <AIAssistantBadge pageContext={pageContext} />
      <BoltBadge position="bottom-left" />
    </>
  );
};

export default AILayout;